// client/src/components/common/TimeRangeSlider.js

import React from 'react';
import { Range, getTrackBackground } from 'react-range';

const STEP = 1;
const MIN = 6; // 6:00 AM
const MAX = 21; // 9:00 PM

const TimeRangeSlider = ({ timeRange, setTimeRange }) => {
  // Helper to format the time labels
  const formatTime = (hour) => {
    const ampm = hour >= 12 ? 'PM' : 'AM';
    const formattedHour = hour > 12 ? hour - 12 : hour === 0 ? 12 : hour;
    return `${formattedHour}:00 ${ampm}`;
  };

  return (
    <div>
      <div className="py-2">
        <Range
          values={timeRange}
          step={STEP}
          min={MIN}
          max={MAX}
          onChange={setTimeRange}
          renderTrack={({ props, children }) => (
            <div
              onMouseDown={props.onMouseDown}
              onTouchStart={props.onTouchStart}
              style={{
                ...props.style,
                height: '36px',
                display: 'flex',
                width: '100%',
              }}
            >
              <div
                ref={props.ref}
                style={{
                  height: '8px', // Thicker track
                  width: '100%',
                  borderRadius: '4px',
                  // ✅ Use getTrackBackground for a professional look
                  background: getTrackBackground({
                    values: timeRange,
                    colors: ['#ccc', 'var(--bs-primary)', '#ccc'], // Gray, Primary, Gray
                    min: MIN,
                    max: MAX,
                  }),
                  alignSelf: 'center',
                }}
              >
                {children}
              </div>
            </div>
          )}
          renderThumb={({ props }) => (
            <div
              {...props}
              style={{
                ...props.style,
                height: '24px',
                width: '24px',
                borderRadius: '50%',
                // ✅ Use the rgb variable to ensure a solid color
                backgroundColor: 'rgb(var(--bs-primary-rgb))',
                boxShadow: '0px 2px 6px #AAA', // Subtle shadow
              }}
            />
          )}
        />
      </div>
      <div className="d-flex justify-content-between mt-2">
        {/* ✅ Use the helper for cleaner labels */}
        <span>{formatTime(timeRange[0])}</span>
        <span>{formatTime(timeRange[1])}</span>
      </div>
    </div>
  );
};

export default TimeRangeSlider;